module.exports = window["nab"]["experiments"];